class FreeShippingProgress extends HTMLElement {
  connectedCallback() {
    this.update(Number(this.dataset.total || 0));
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(this.dataset.locale || 'en-US', {
      style: 'currency',
      currency: this.dataset.currency || 'USD',
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  update(total) {
    const threshold = Number(this.dataset.threshold || 5000);
    const safeTotal = Math.max(0, Number(total || 0));
    const remaining = Math.max(0, threshold - safeTotal);
    const message = this.querySelector('[data-progress-message]');
    const fill = this.querySelector('[data-progress-fill]');
    const track = this.querySelector('[role="progressbar"]');

    this.dataset.total = safeTotal;
    if (message) {
      message.textContent =
        remaining > 0
          ? this.dataset.remainingTemplate.replace('[amount]', this.formatMoney(remaining))
          : this.dataset.unlockedTemplate;
    }
    if (fill) fill.style.width = `${Math.min(100, (safeTotal / threshold) * 100)}%`;
    if (track) track.setAttribute('aria-valuenow', Math.min(safeTotal, threshold));
  }
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', FreeShippingProgress);
}

window.updatePupsFreeShippingProgress = (cart) => {
  document.querySelectorAll('free-shipping-progress').forEach((element) => element.update(cart?.total_price));
};
